import { defineMessages } from 'react-intl';

export default defineMessages({
    editDebitCardTitle: {
        id: '_.edit_debit_card_title',
        defaultMessage: 'Card ●●●● {cardNumber}'
    },
    deletePaymentMethod: {
        id: '_.edit_debit_card.delete_payment_method',
        defaultMessage: 'Delete payment method'
    },
    deleteConfirmation: {
        id: '_.edit_debit_card.delete_confirmation',
        defaultMessage: 'Are you sure?'
    },
    confirmAction: {
        id: '_.edit_debit_card.confirm_action',
        defaultMessage: 'Yes'
    },
    cancelAction: {
        id: '_.edit_debit_card.cancel_action',
        defaultMessage: 'No'
    }
});
